module.exports = __webpack_public_path__ + "img/platinumGold.681c30e.jpg";